import isEmpty from "lodash-es/isEmpty"
import map from "lodash-es/map"

import type {
    ICoachCalendarMsTeamsAccountDto as IMsTeamsAccountDto,
    ICoachCalendarMsTeamsAccountModel as IMsTeamsAccountModel,
    ICoachCalendarRelinkAccountBaseModel as IRelinkAccountBaseModel,
    ICoachCalendarRelinkAccountCalendarDto as IRelinkAccountCalendarDto,
    ICoachCalendarRelinkAccountCalendarModel as IRelinkAccountCalendarModel,
    ICoachCalendarRelinkAccountDto as IRelinkAccountDto,
    ICoachCalendarRelinkAccountsQueryDto as IRelinkAccountsQueryDto,
    ICoachCalendarRelinkAccountsQueryModel as IRelinkAccountsQueryModel,
    ICoachCalendarZoomAccountDto as IZoomAccountDto,
    ICoachCalendarZoomAccountModel as IZoomAccountModel
} from "./coach.calendar.api.types"

function zoomAccount(dto: IZoomAccountDto): IZoomAccountModel {
    return isEmpty(dto) ? null : { profileId: dto.profile_id, profileName: dto.profile_name, url: dto.url }
}

function msTeamsAccount(dto: IMsTeamsAccountDto): IMsTeamsAccountModel {
    return isEmpty(dto) ? null : { profileId: dto.profile_id, profileName: dto.profile_name, url: dto.url }
}

function relinkAccounts(dto: IRelinkAccountsQueryDto): IRelinkAccountsQueryModel {
    function _baseAccountMapper(dto: IRelinkAccountDto): IRelinkAccountBaseModel {
        return isEmpty(dto)
            ? null
            : { profileId: dto.profile_id, profileName: dto.profile_name, relinkUrl: dto.relink_url }
    }

    return isEmpty(dto)
        ? null
        : {
              calendars: map<IRelinkAccountCalendarDto, IRelinkAccountCalendarModel>(
                  dto.calendar_profiles,
                  (c: IRelinkAccountCalendarDto): IRelinkAccountCalendarModel => ({
                      isPrimaryAccount: c.profile_primary,
                      disconnectUrl: c.disconnect_url,
                      ..._baseAccountMapper(c)
                  })
              ),
              zoom: _baseAccountMapper(dto.zoom_profile),
              msTeams: _baseAccountMapper(dto.ms_teams_profile)
          }
}

export default { zoomAccount, msTeamsAccount, relinkAccounts }
